import dayjs, { OpUnitType } from 'shared/dayjs'
import { defaultDateRange } from '../../components/utils/predefinedDateRanges'
import {
  ActivityHistoryOrderColumn,
  SqlOrderDirectionEnum,
  WorkbookStatusEnum
} from '../../graphql/private/PrivateSchemaTypes'
import { ActivityHistoryTypeEnum } from './activityHistoryTypes'
import { ActivityHistoryQueryVariables } from 'front-end/src/pages/activity-history/ActivityHistory.codegen'

export const DEFAULT_ACTIVITY_LIMIT = 20
export const DEFAULT_ACTIVITY_SEARCH_LIMIT = 255

export const DEFAULT_TABLE_FILTERS: Omit<
  ActivityHistoryQueryVariables['filters'],
  'from' | 'to' | 'cpdOnly'
> = {
  orderColumn: ActivityHistoryOrderColumn.startedAt,
  orderDirection: SqlOrderDirectionEnum.DESC,
  limit: DEFAULT_ACTIVITY_LIMIT,
  page: 1,
  search: ''
}

export const getDefaultActivityDateFilters = () => ({
  from: dayjs()
    .subtract(defaultDateRange.amount, defaultDateRange.unit as OpUnitType)
    .startOf('day'),
  to: dayjs().endOf('day')
})

export const ACTIVITY_HISTORY_STATUSES = {
  COMPLETED: 'Completed',
  IN_PROGRESS: 'In progress',
  FAILED: 'Failed',
  ATTENDED: 'Attended',
  OVERDUE: 'Overdue'
}

export const ACTIVITY_TYPE_NAMES = {
  [ActivityHistoryTypeEnum.CPDManualEntryModel]: 'External activity',
  [ActivityHistoryTypeEnum.UserEventModel]: 'Event',
  [ActivityHistoryTypeEnum.TopicEnrolmentModelAsStudent]: 'Resource'
}

export const ACTIVITY_HISTORY_TOPIC_STATUES = {
  [WorkbookStatusEnum.COMPLETED]: ACTIVITY_HISTORY_STATUSES.COMPLETED,
  [WorkbookStatusEnum.IN_PROGRESS]: ACTIVITY_HISTORY_STATUSES.IN_PROGRESS,
  [WorkbookStatusEnum.FAILED]: ACTIVITY_HISTORY_STATUSES.FAILED,
  [WorkbookStatusEnum.OVERDUE]: ACTIVITY_HISTORY_STATUSES.OVERDUE
}
